export default [
    {
        text: 'Amazon',
        value: 'amazon'
    },
    {
        text: 'Shopify',
        value: 'shopify'
    },
    {
        text: 'EBay',
        value: 'ebay'
    },
    {
        text: 'Etsy',
        value: 'etsy'
    },
]



// WEBPACK FOOTER //
// ./src/assets/js/table-options/originItem.js